import { DataService } from '../dataService';

export const instructorServices = {
  getInstructorBook: () => {
    return DataService.get('/instructor/book');
  },
  getInstructorBookDetail: (id) => {
    return DataService.get(`/instructor/book-chapters-headers-slug/${id}`);
  },
  getInstructorMainBookDetail: (id) => {
    return DataService.get(`/instructor/main-book/${id}`);
  },

  /// read api for chapter header

  getInstructorPaginationApi: (id) => {
    return DataService.get(`/instructor/chapters-headers-sequence-slug/${id}`);
  },

  getChapterHeaderApi: (id, data) => {
    return DataService.get(`/instructor/chapter/${id}`, data);
  },
  getHeaderOneApi: (id, data) => {
    return DataService.get(`/instructor/header-1-clone/${id}`, data);
  },
  getHeaderTwoApi: (id, data) => {
    return DataService.get(`/instructor/header-2-clone/${id}`, data);
  },
  getHeaderThreeApi: (id, data) => {
    return DataService.get(`/instructor/header-3-clone/${id}`, data);
  },

  /// read api Main Book get Api

  getInstructorMainPaginationApi: (id) => {
    return DataService.get(`/instructor/main-chapter-sequence-slug/${id}`);
  },

  getChapterHeaderMainApi: (id, data) => {
    return DataService.get(`/instructor/main-chapter/${id}`, data);
  },
  getHeaderMainOneApi: (id, data) => {
    return DataService.get(`/instructor/main/header-1/${id}`, data);
  },
  getHeaderMainTwoApi: (id, data) => {
    return DataService.get(`/instructor/main/header-2/${id}`, data);
  },
  getHeaderMainThreeApi: (id, data) => {
    return DataService.get(`/instructor/main/header-3/${id}`, data);
  },

  /// swap api

  swapChapter: (data) => {
    return DataService.patch('/instructor/swap/chapter-clone', data);
  },
  swapHeaderOne: (data) => {
    return DataService.patch('/instructor/swap/header-1-clone', data);
  },
  swapHeaderTwo: (data) => {
    return DataService.patch('/instructor/swap/header-2-clone', data);
  },
  swapHeaderThree: (data) => {
    return DataService.patch('/instructor/swap/header-3-clone', data);
  },

  /// Create Instructor clone api

  instructorChapterCreate: (data) => {
    return DataService.post(`/instructor/chapter`, data);
  },
  instructorHeaderOneCreate: (data) => {
    return DataService.post(`/instructor/header-1-clone`, data);
  },
  instructorHeaderTwoCreate: (data) => {
    return DataService.post(`/instructor/header-2-clone`, data);
  },
  instructorHeaderThreeCreate: (data) => {
    return DataService.post(`/instructor/header-3-clone`, data);
  },

  /// Update Instructor clone api

  instructorChapterUpdate: (id, data) => {
    return DataService.put(`/instructor/chapter/${id}`, data);
  },
  instructorHeaderOneUpdate: (id, data) => {
    return DataService.put(`/instructor/header-1-clone/${id}`, data);
  },
  instructorHeaderTwoUpdate: (id, data) => {
    return DataService.put(`/instructor/header-2-clone/${id}`, data);
  },
  instructorHeaderThreeUpdate: (id, data) => {
    return DataService.put(`/instructor/header-3-clone/${id}`, data);
  },

  /// Delete Instructor clone api

  instructorChapterDelete: (id, data) => {
    return DataService.delete(`/instructor/chapter/${id}`, data);
  },

  deleteChapterHeaderApi: (type, id, data) => {
    if (type == 'header-1-clone') {
      return DataService.delete(`/instructor/header-1-clone/${id}`, data);
    }
    if (type == 'header-2-clone') {
      return DataService.delete(`/instructor/header-2-clone/${id}`, data);
    }
    if (type == 'header-3-clone') {
      return DataService.delete(`/instructor/header-3-clone/${id}`, data);
    }
  },

  // slug api call
  getInstructorChapterSlug: (id) => {
    return DataService.get(`static/slug/chapters-clone/${id}`);
  },
  getInstructorHeaderOneSlug: (id) => {
    return DataService.get(`static/slug/header-1-clone/${id}`);
  },
  getInstructorHeaderTwoSlug: (id) => {
    return DataService.get(`static/slug/header-2-clone/${id}`);
  },
  getInstructorHeaderThreeSlug: (id) => {
    return DataService.get(`static/slug/header-3-clone/${id}`);
  },

  // update clone book cost
  updateCloneBookCost: (data) => {
    return DataService.patch(`instructor/clone-book-cost`, data);
  },
};
